<template>
    <b-modal
        id="login-modal"
        size="lg"
        v-model="loginFormVisible"
        :hide-footer="true"
        @hide="modalClosed"
    >
        <template #modal-header="{ close }">
            <div class="header-left">
                <b-link
                    class="login-form-link"
                    :class="{ 'active-form-link': activeFrom === 'login' }"
                    @click="toggleForm('login')"
                    >Ieiet</b-link
                >
                |
                <b-link
                    class="register-form-link"
                    :class="{ 'active-form-link': activeFrom === 'register' }"
                    @click="toggleForm('register')"
                    >Reģistrēties</b-link
                >
            </div>
            <b-icon
                class="close-icon"
                icon="x-circle-fill"
                @click="close()"
            ></b-icon>
        </template>

        <!-- Login -->

        <div v-if="activeFrom === 'login'" class="login-form pt-2">
            <b-row v-if="showAuthRequiredMessage" class="pb-2">
                <b-col cols="12 auth-required-message">
                    <h4>
                        Autorizējieties sistēmā, lai pievienotu jaunu vārdu!
                    </h4>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" sm="5" class="ml-4 username">
                    <b-form-group
                        class=""
                        :invalid-feedback="loginFormErrors.email"
                        :state="!loginFormErrors.email"
                    >
                        <b-form-input
                            @keyup.enter="login"
                            v-model="loginForm.email"
                            class="mr-sm-4"
                            placeholder="E-pasts"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <!-- <b-col cols="12" sm="1"></b-col> -->
                <b-col cols="12" sm="5">
                    <b-form-group
                        class=""
                        :invalid-feedback="loginFormErrors.password"
                        :state="!loginFormErrors.password"
                    >
                        <b-form-input
                            @keyup.enter="login"
                            v-model="loginForm.password"
                            type="password"
                            placeholder="Parole"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12" sm="1" class="login-button-wrapper">
                    <b-button @click="login()" class="login-button"
                        >Ieiet</b-button
                    >
                    <!-- <b-img
                        @click="login()"
                        class="submit-image"
                        src="/images/apvidvardi-button-submit.png"
                    ></b-img> -->
                    <b-icon
                        class="submit-image"
                        icon="arrow-right-circle"
                        @click="login()"
                    ></b-icon>
                </b-col>
            </b-row>
            <b-row class="forgot-password-form-row">
                <b-col cols="12" sm="5" class="ml-4 empty-col"></b-col>
                <!-- <b-col cols="12" sm="1"></b-col> -->
                <b-col cols="12" sm="5">
                    <b-link
                        @click="toPasswordResetLinkRequestForm()"
                        class="forgot-password-link"
                        >Aizmirsi paroli?</b-link
                    >
                </b-col>
                <b-col cols="12" sm="1"></b-col>
            </b-row>
            <hr />
            <b-row class="social-auth">
                <b-col cols="12" class="auth-buttons">
                    <b-button
                        @click="useAuthProvider('google', null)"
                        class="google-button"
                    >
                        <b-img
                            class="google-image"
                            src="/images/google.png"
                        ></b-img>
                        <span class="pl-2">Google</span>
                    </b-button>
                    <span class="pt-2 pb-2">vai</span>
                    <b-button
                        @click="useAuthProvider('facebook', Facebook)"
                        class="facebook-button"
                    >
                        <b-img
                            class="facebook-image"
                            src="/images/facebook.png"
                        ></b-img>
                        <span class="pl-2">Facebook</span>
                    </b-button>
                </b-col>
            </b-row>
        </div>

        <!-- Registration -->

        <div v-if="activeFrom === 'register'" class="register-form pt-2">
            <div class="registration" v-if="!verificationLinkSent">
                <b-row>
                    <!-- <b-col cols="12" sm="6">
                        <b-form-group
                            :invalid-feedback="registerFormErrors.first_name"
                            :state="!registerFormErrors.first_name"
                        >
                            <b-form-input
                                @keyup.enter="register"
                                v-model="registerForm.first_name"
                                class=""
                                placeholder="Vārds"
                            ></b-form-input>
                        </b-form-group>
                    </b-col> -->
                    <b-col cols="12" sm="6">
                        <b-form-group
                            :invalid-feedback="registerFormErrors.nickname"
                            :state="!registerFormErrors.nickname"
                        >
                            <b-form-input
                                @keyup.enter="register"
                                v-model="registerForm.nickname"
                                placeholder="Lietotājvārds"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6">
                        <b-form-group
                            :invalid-feedback="registerFormErrors.email"
                            :state="!registerFormErrors.email"
                        >
                            <b-form-input
                                @keyup.enter="register"
                                v-model="registerForm.email"
                                placeholder="E-pasts"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <!-- <b-row>
                    <b-col cols="12" sm="6">
                        <b-form-group
                            :invalid-feedback="registerFormErrors.last_name"
                            :state="!registerFormErrors.last_name"
                        >
                            <b-form-input
                                @keyup.enter="register"
                                v-model="registerForm.last_name"
                                class=""
                                placeholder="Uzvārds"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6">
                        <b-form-group
                            :invalid-feedback="registerFormErrors.nickname"
                            :state="!registerFormErrors.nickname"
                        >
                            <b-form-input
                                @keyup.enter="register"
                                v-model="registerForm.nickname"
                                placeholder="Iesauka"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row> -->
                <b-row>
                    <b-col cols="12" sm="6">
                        <b-form-group
                            :invalid-feedback="registerFormErrors.password"
                            :state="!registerFormErrors.password"
                        >
                            <b-form-input
                                @keyup.enter="register"
                                v-model="registerForm.password"
                                class=""
                                placeholder="Parole"
                                type="password"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6">
                        <b-form-group
                            :invalid-feedback="registerFormErrors.password"
                            :state="!registerFormErrors.password"
                        >
                            <b-form-input
                                @keyup.enter="register"
                                class=""
                                v-model="registerForm.password_confirmation"
                                placeholder="Parole vēlreiz"
                                type="password"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <hr />
                <b-row>
                    <b-col cols="12" sm="6"></b-col>
                    <b-col cols="12" sm="6" class="approve-registration">
                        <b-button
                            @click="register()"
                            :disabled="registrationInProgress"
                            class="create-account-button"
                            >Izveidot kontu</b-button
                        >
                    </b-col>
                </b-row>
            </div>
            <div class="verify" v-if="verificationLinkSent">
                Lietotāja konta aktivizēšanas saite ir nosūtīta uz Jūsu norādīto
                e-pasta adresi.
            </div>
        </div>
    </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { Providers } from "universal-social-auth";

export default {
    name: "loginForm",
    props: {
        selectedForm: String,
        showAuthRequiredMessage: Boolean,
    },
    data: () => ({
        loginForm: {
            email: "",
            password: "",
        },
        loginFormVisible: true,
        loginFormErrors: {},
        registerForm: {
            first_name: "",
            last_name: "",
            nickname: "",
            email: "",
            passowrd: "",
            password_confirmation: "",
        },
        registerFormErrors: {},
        activeFrom: "login",
        verificationLinkSent: false,
        registrationInProgress: false,
        Facebook: {
            name: "facebook",
            url: "/auth/facebook",
            authorizationEndpoint: "https://www.facebook.com/v9.0/dialog/oauth",
            redirectUri: window.location.origin + "/",
            responseMode: ["form_post"],
            requiredUrlParams: ["scope", "auth_type"],
            defaultUrlParams: [
                "response_type",
                "client_id",
                "redirect_uri",
                "auth_type",
            ],
            scope: ["email"],
            authType: "rerequest",
            scopeDelimiter: ",",
            display: "popup",
            oauthType: "2.0",
            popupOptions: { width: 580, height: 400 },
        },
    }),
    methods: {
        ...mapActions({
            signIn: "auth/signIn",
            registerNewUser: "auth/registerNewUser",
            checkIfUserRegistered: "auth/checkIfUserRegistered",
            sendResetLinkEmail: "auth/sendResetLinkEmail",
            socialLoginCallback: "auth/socialLoginCallback",
            getNewestToponym: "toponyms/getNewestToponym",
            getNewestTOponymOfTheMonth:
                "toponymOfTheMonth/getNewestTOponymOfTheMonth",
            getAllToponymsCount: "toponyms/getAllToponymsCount",
        }),
        async login() {
            this.loginFormErrors = {};
            await this.signIn(this.loginForm)
                .then(() => {
                    this.loginFormVisible = false;
                    this.modalClosed({
                        showMessage: true,
                        title: "Darbības apstiprinājums",
                        body: "Autorizācija sekmīga!",
                        variant: "success",
                    });
                })
                .catch((error) => {
                    const errorsData = error.response;

                    if (errorsData.status == 403) {
                        let errorMessages = {};
                        errorMessages.email = "E-pasts nav aktivizēts";
                        this.loginFormErrors = errorMessages;
                    }

                    if (errorsData && errorsData.data.errors) {
                        const errorKeys = Object.keys(errorsData.data.errors);
                        let errorMessages = {};
                        errorKeys.forEach((key) => {
                            errorMessages[key] = errorsData.data.errors[key][0];
                        });
                        this.loginFormErrors = errorMessages;
                    }
                    this.$bvToast.toast(
                        "Autorizācija neveiksmīga, pārbaudiet ievadītos datus!",
                        {
                            title: "Darbības atcelta",
                            variant: "danger",
                        }
                    );
                });
        },
        async register() {
            this.registerFormErrors = {};
            this.registrationInProgress = true;
            await this.registerNewUser(this.registerForm)
                .then((response) => {
                    this.verificationLinkSent = true;
                    this.registrationInProgress = false;
                    // this.loginFormVisible = false;
                    // this.modalClosed({
                    //     showMessage: true,
                    //     title: "Darbības apstiprinājums",
                    //     body: "Reģistrācija sekmiga!",
                    //     variant: "success",
                    // });
                })
                .catch((error) => {
                    const errorsData = error.response;
                    if (errorsData && errorsData.data.errors) {
                        const errorKeys = Object.keys(errorsData.data.errors);
                        let errorMessages = {};
                        errorKeys.forEach((key) => {
                            errorMessages[key] = errorsData.data.errors[key][0];
                        });
                        this.registerFormErrors = errorMessages;
                        this.$bvToast.toast(
                            "Reģistrācija neveiksmīga, pārbaudiet ievadītos datus!",
                            {
                                title: "Darbības atcelta",
                                variant: "danger",
                            }
                        );
                        this.registrationInProgress = false;
                    }
                });
        },
        toggleForm(value) {
            this.clearAuthForms();
            this.activeFrom = value;
        },
        clearAuthForms() {
            this.loginForm = {
                name: "",
                password: "",
            };
            this.loginFormErrors = {};
            this.registerForm = {
                first_name: "",
                last_name: "",
                nickname: "",
                email: "",
                passowrd: "",
                password_confirmation: "",
            };
            this.registerFormErrors = {};
        },
        modalClosed(data) {
            this.$emit("closeAuthModal", data);
        },
        toPasswordResetLinkRequestForm() {
            this.$emit("closeAuthModal", true);
            if (this.$route.name !== "sendResetPasswordLink") {
                this.$router.push({ name: "sendResetPasswordLink" });
            }
        },
        useAuthProvider(provider, proData) {
            const pro = proData;
            const ProData = pro || Providers[provider];
            this.$Oauth
                .authenticate(provider, ProData)
                .then((response) => {
                    // console.log("prosvider", response);
                    const rsp = response;
                    if (rsp.code) {
                        this.socialLogin(provider, { code: rsp.code });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async socialLogin(provider, response) {
            // console.log("socialLogin", provider, response);
            await this.socialLoginCallback({ provider, data: response })
                .then(() => {
                    this.loginFormVisible = false;
                    const providerName =
                        provider.charAt(0).toUpperCase() + provider.slice(1);
                    this.modalClosed({
                        showMessage: true,
                        title: "Darbības apstiprinājums",
                        body: `Autorizācija ar ${providerName} sekmīga!`,
                        variant: "success",
                    });
                })
                .catch((error) => {
                    const errorsData = error.response;
                    // console.log("errorsData", errorsData);
                    if (
                        errorsData &&
                        errorsData.data.error === "missing_email"
                    ) {
                        this.$bvToast.toast(
                            "Autorizācija neizdevās! Lai lietotu aplikāciju, nepieciešama Jūs atļauja reģistrēt Jūsu e-pastu mūsu sistēmā!",
                            {
                                title: "Darbības atcelta",
                                variant: "danger",
                            }
                        );
                    }
                });
        },
    },
    mounted() {
        this.activeFrom = this.selectedForm;
    },
};
</script>

<style lang="scss" scoped>
@import "~@/_variables.scss";

.header-left {
    font-size: 20px;
}
.close-icon {
    color: $grey-text;
    cursor: pointer;
    width: 20px;
    height: 20px;
}

.active-form-link {
    color: #000 !important;
    text-decoration: underline !important;
}

.login-form-link,
.register-form-link {
    color: $grey-text;
    text-decoration: none;
}

.login-form {
    align-items: center;

    .login-button-wrapper {
        display: flex;
        align-items: center;
        height: 38px;
    }

    .submit-image {
        width: 32px;
        height: 32px;
        cursor: pointer;
        color: $white;
        border-radius: 50%;
        background-image: linear-gradient($gradient-yellow, $gradient-red);
    }
}

.forgot-password-form-row {
    padding-bottom: 16px;
    margin-top: 8px;

    .forgot-password-link {
        color: $black;
    }
}

.approve-registration {
    display: flex;
    justify-content: flex-end;
}

.create-account-button {
    background-image: linear-gradient($gradient-yellow, $gradient-red);
    font-weight: 700;
}

.auth-required-message {
    color: $red;
    text-align: center;
}

.auth-buttons {
    // align-items: center;

    span {
        text-align: center;
        display: block;
    }
}
.google-button,
.facebook-button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 260px;
    background-color: $white;
    color: $grey-text;
    margin: 0 auto;
}

.google-image,
.facebook-image {
    width: 32px;
    height: 32px;
}

.login-button {
    display: none;
}

@media (max-width: $xs-media) {
    .login-button {
        background-image: linear-gradient($gradient-yellow, $gradient-red);
        font-weight: 700;
        display: block;
    }

    .submit-image {
        display: none;
    }

    .login-button,
    .create-account-button {
        width: 100%;
    }

    .auth-buttons {
        button {
            width: 100%;
        }
    }

    .username,
    .empty-col {
        margin-left: 0 !important;
    }
}
</style>
